export default "__VITE_ASSET__DZKU0JZh__"